/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type BuildingClass = (typeof BuildingClass)[keyof typeof BuildingClass];

export const BuildingClass = {
    Class1a: 1,
    Class1b: 2,
    Class2: 3,
    Class3: 4,
    Class4: 5,
    Class5: 6,
    Class6: 7,
    Class7a: 8,
    Class7b: 9,
    Class8: 10,
    Class9a: 11,
    Class9b: 12,
    Class9c: 13,
    Class10a: 14,
    Class10b: 15,
    Class10c: 16,
} as const;
